import { get } from "@/helpers/api.helper";
import { EVENT_PUBLISHED, EVENT_DOWNLOAD_IMAGE } from "@/constants/urls";
import { EventData } from "@/models/api/event";

/**
 * Fetches all publicly published, active events.
 */
export const getPublishedEvents = async (): Promise<EventData[]> => {
  const data = await get<any[]>(EVENT_PUBLISHED);
  const events = Array.isArray(data) ? data : [];

  return events.map((event: any) => ({
    ...event,
    id: event.id,
    fileUrl: event.fileUrl ? EVENT_DOWNLOAD_IMAGE(event.id) : "",
  }));
};
